<template>
  <section class="section">
    <Loader :isLoading="this.isLoading"></Loader>

    <div v-if="!isLoading" class="section">
      <div class="column is-10-desktop is-offset-1-desktop is-12-mobile">
        <div class="content">
          <h1>Képzések</h1>
          <TrainingSearchBar
            :searchRoute="'trainings'"
            :placeholder="'Keressen dátum, helyszín vagy témakör alapján'">
          </TrainingSearchBar>
        </div>

        <div v-if="filteredTrainings.length">
          <div class="content">
            <h3>Találatok</h3>
          </div>

          <div class="columns is-multiline">
            <div class="column is-12 has-background-warning">
              <div v-for="filteredTraining in filteredTrainings"
                   :key="filteredTraining.sys.id + '-filtered'">
                  <TrainingSummaryCard :training="filteredTraining"></TrainingSummaryCard>
              </div>
            </div>
          </div>

          <div class="content">
            <h3>Összes képzés</h3>
          </div>
        </div>

        <div class="columns is-multiline">
          <div class="column is-4-desktop is-6-tablet is-12-mobile"
               v-for="training in trainings"
               :key="training.sys.id">
            <TrainingSummaryCard :training="training"></TrainingSummaryCard>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
  /* Services */
  import moment from 'moment'
  import Contentful from '@/services/Contentful'

  /* Components */
  import TrainingSearchBar from '@/components/General/SearchBar'
  import TrainingSummaryCard from '@/components/General/TrainingSummaryCard'
  import Loader from '@/components/General/Loader'

  export default {
    data () {
      return {
        trainings: [],
        filteredTrainings: [],
        isLoading: true
      }
    },
    async mounted () {
      /* Get trainings, sort by date */
      this.trainings = (await Contentful.getAllEntriesByContentType('training')).data.items
      this.trainings = this.trainings.sort((a, b) => {
        return moment(b.fields.date).unix() - moment(a.fields.date).unix()
      })
      this.isLoading = false
      /* Scroll to top */
      window.scrollTo(0, 0)
    },
    watch: {
      '$route.query.q': {
        immediate: true,
        async handler (queryString) {
          this.filteredTrainings = (await Contentful.getAllEntriesByContentTypeAndQuery('training', queryString)).data.items
        }
      }
    },
    components: {
      TrainingSearchBar,
      TrainingSummaryCard,
      Loader
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Pages/Trainings.vue